import styled from 'styled-components'
import * as color from '../constants/colors'

export const Dropdown = styled.div`
  background-color: ${color.SAND_1};
`
